import api from '../utilities/api';
import { getCookie } from '../utilities/cookie';

const getConsultation = (id) => {
  return api.get(`/ks/consultations/external/${id}/`);
};

const getConsultationForm = (id) => {
  return api.get(`/ks/consultations/${id}/`);
};

const postConsultation = (id, data) => {
  return api.post(`/ks/consultations/${id}/external-opinions/`, data);
};

const getMyConsultations = (params) => {
  return api.get(`/ks/opinions/user/${getCookie('mu_id')}/opinions/`, {
    params: { ...params, name__contains: params?.search ?? '' },
  });
};

const getConsultationOpinion = (id) => {
  return api.get(`/ks/opinions/${id}/`);
};

export {
  getConsultation,
  postConsultation,
  getMyConsultations,
  getConsultationOpinion,
  getConsultationForm,
};
